/* eslint-disable camelcase */
/* eslint-disable max-len */
import React from 'react';
import classNames from 'classnames';

const ns = `line-item__custom-attributes`;

const CustomAttributes = ({
	attributes = [],
}) => {
	const attributesToRender = attributes
		.filter(({ key }) => {
			return key.charAt(0) !== '_';
		})
		.sort((a, b) => {
			if (a.key === 'PN') return -1;
			return a.key.localeCompare(b.key);
		});

	const rootClassnames = classNames({
		[`${ ns }`]: true,
	});

	if (!attributesToRender?.length) return null;

	return (
		<ul className={rootClassnames}>
			{attributesToRender.map((attributeData = {}, i) => {
				const { key, value } = attributeData || {};
				return (
					<li key={`${ key + i }`}>{`${ value ? `${ key }: ` : key } ${ value }`}</li>
				);
			})}
		</ul>
	);
};

export default CustomAttributes;
